import { render } from "./addComplaints.vue?vue&type=template&id=1439b691&scoped=true"
import script from "./addComplaints.vue?vue&type=script&lang=js"
export * from "./addComplaints.vue?vue&type=script&lang=js"

import "./addComplaints.vue?vue&type=style&index=0&id=1439b691&scoped=true&lang=css"
import "./addComplaints.vue?vue&type=style&index=1&id=1439b691&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1439b691"]])

export default __exports__